import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FlowLineageCountsFragmentGql } from './FlowLineageCountsFragmentGql';

export const FlowLineageCountsFilteredByFieldQueryGql: DocumentNode = gql`
query FlowLineageCountsFilteredByFieldQuery($flowVizportalUrlId: String!, $outputStepId: ID!, $selectedFieldId: ID!, $publishedConnectionsLineageEnabled: Boolean!) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    ...FlowLineageCountsFragment
    outputSteps(filter: { id: $outputStepId }) {
      filteredFieldsConnection: outputFieldsConnection(filter: { id: $selectedFieldId }) {
        nodes {
          name
          upstreamDatabasesConnection {
            totalCount
          }
          upstreamTablesConnection {
            totalCount
          }
          upstreamVirtualConnectionsConnection @flag(enabled: $publishedConnectionsLineageEnabled) {
            totalCount
          }
          upstreamVirtualConnectionTablesConnection @flag(enabled: $publishedConnectionsLineageEnabled) {
            totalCount
          }
          upstreamFlowsConnection {
            totalCount
          }
          upstreamDatasourcesConnection {
            totalCount
          }
          downstreamDatabasesConnection {
            totalCount
          }
          downstreamTablesConnection {
            totalCount
          }
          downstreamFlowsConnection {
            totalCount
          }
          downstreamDatasourcesConnection {
            totalCount
          }
          downstreamWorkbooksConnection {
            totalCount
          }
          downstreamDashboardsConnection {
            totalCount
          }
          downstreamSheetsConnection {
            totalCount
          }
          downstreamMetricsConnection {
            totalCount
          }
          downstreamOwnersConnection {
            totalCount
          }
        }
      }
    }
  }
}
${FlowLineageCountsFragmentGql}
`;
